import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Input from '../input';
import Select from '../select';
import { RoleAllowAdmin } from '../../auth/roleAware';
import { COUNTRY_NAME_BY_CODE } from '../../main/shops/constants';
import classNames from 'classnames';
import { t } from '../../../modules/infra/i18n';

class AddressForm extends Component {

  constructor(props) {
    super(props);
    this.state = {
      country: props.country,
    };
  }

  onCountryChangeListener = (_, current, prev) => {
    if (current !== prev) {
      this.setState({ country: current });
    }
  }

  renderFields() {
    const fields = [(
      <div className="layout__item" key="country">
        <div className="c-label-new">{t('admin:shops.add.address.country_label')} *</div>
        <Select
          className="c-select"
          empty={t('admin:shops.add.address.select_country_placeholder')}
          placeholder={t('admin:shops.add.address.add_country_placeholder')}
          name="address.country"
          options={Object.values(COUNTRY_NAME_BY_CODE)}
          onChange={this.onCountryChangeListener}
        />
      </div>
    ), (
      <div className="layout__item" key="street">
        <div className="c-label-new">{t('admin:shops.add.address.street_label')} *</div>
        <Input className="c-input" type="text" placeholder={t('admin:shops.add.address.add_street_placeholder')} name="address.street" />
      </div>
    ), (
      <div className="layout__item" key="street2">
        <div className="c-label-new">{t('admin:shops.add.address.street2_label')}</div>
        <Input className="c-input" type="text" placeholder={t('admin:shops.add.address.add_street2_placeholder')} name="address.street2" />
      </div>
    )];

    if (this.state.country === COUNTRY_NAME_BY_CODE.GB) {
      fields.push((
        <div className="layout__item" key="city">
          <div className="c-label-new">{t('admin:shops.add.address.post_town_label')} *</div>
          <Input className="c-input" type="text" placeholder={t('admin:shops.add.address.add_post_town_placeholder')} name="address.city" />
        </div>
      ), (
        <div className="layout__item u-2/3-medium-and-up" key="state">
          <div className="c-label-new">{t('admin:shops.add.address.county_label')} *</div>
          <Input className="c-input" type="text" placeholder={t('admin:shops.add.address.add_county_placeholder')} name="address.state" />
        </div>
      ), (
        <div className="layout__item u-1/3-medium-and-up" key="zip code">
          <div className="c-label-new">{t('admin:shops.add.address.postcode_label')} *</div>
          <Input className="c-input" type="text" placeholder={t('admin:shops.add.address.add_postcode_placeholder')} name="address.zip" />
        </div>
      ));
    }

    if (this.state.country === COUNTRY_NAME_BY_CODE.CA) {
      fields.push((
        <div className="layout__item" key="city">
          <div className="c-label-new">{t('admin:shops.add.address.municipality_label')} *</div>
          <Input className="c-input" type="text" placeholder={t('admin:shops.add.address.add_city_placeholder')} name="address.city" />
        </div>
      ), (
        <div className="layout__item u-2/3-medium-and-up" key="state">
          <div className="c-label-new">{t('admin:shops.add.address.province_label')} *</div>
          <Input className="c-input" type="text" placeholder={t('admin:shops.add.address.add_province_placeholder')} name="address.state" />
        </div>
      ), (
        <div className="layout__item u-1/3-medium-and-up" key="zip code">
          <div className="c-label-new">{t('admin:shops.add.address.postal_code_label')} *</div>
          <Input className="c-input" type="text" placeholder={t('admin:shops.add.address.add_post_code_placeholder')} name="address.zip" />
        </div>
      ));
    }

    if (this.state.country === COUNTRY_NAME_BY_CODE.US) {
      fields.push((
        <div className="layout__item" key="city">
          <div className="c-label-new">{t('admin:shops.add.address.city_label')} *</div>
          <Input className="c-input" type="text" placeholder={t('admin:shops.add.address.add_city_placeholder')} name="address.city" />
        </div>
      ), (
        <div className="layout__item u-2/3-medium-and-up" key="state">
          <div className="c-label-new">{t('admin:shops.add.address.state_label')} *</div>
          <Input className="c-input" type="text" placeholder={t('admin:shops.add.address.add_state_placeholder')} name="address.state" />
        </div>
      ), (
        <div className="layout__item u-1/3-medium-and-up" key="zip code">
          <div className="c-label-new">{t('admin:shops.add.address.zip_code_label')} *</div>
          <Input className="c-input" type="text" placeholder={t('admin:shops.add.address.add_zip_code_placeholder')} name="address.zip" />
        </div>
      ));
    }

    if (this.state.country === COUNTRY_NAME_BY_CODE.IE) {
      fields.push((
        <div className="layout__item" key="city">
          <div className="c-label-new">{t('admin:shops.add.address.city_town_label')} *</div>
          <Input className="c-input" type="text" placeholder={t('admin:shops.add.address.add_city_town_placeholder')} name="address.city" />
        </div>
      ), (
        <div className="layout__item u-2/3-medium-and-up" key="state">
          <div className="c-label-new">{t('admin:shops.add.address.county_label')} *</div>
          <Input className="c-input" type="text" placeholder={t('admin:shops.add.address.add_county_placeholder')} name="address.state" />
        </div>
      ), (
        <div className="layout__item u-1/3-medium-and-up" key="zip code">
          <div className="c-label-new">{t('admin:shops.add.address.eircode_label')} *</div>
          <Input className="c-input" type="text" placeholder={t('admin:shops.add.address.add_eircode_placeholder')} name="address.zip" />
        </div>
      ));
    }

    if (this.state.country === COUNTRY_NAME_BY_CODE.AU) {
      fields.push((
        <div className="layout__item" key="city">
          <div className="c-label-new">{t('admin:shops.add.address.city_town_locality_label')} *</div>
          <Input className="c-input" type="text" placeholder={t('admin:shops.add.address.add_city_town_placeholder')} name="address.city" />
        </div>
      ), (
        <div className="layout__item u-2/3-medium-and-up" key="state">
          <div className="c-label-new">{t('admin:shops.add.address.state_territory_label')} *</div>
          <Input className="c-input" type="text" placeholder={t('admin:shops.add.address.add_county_placeholder')} name="address.state" />
        </div>
      ), (
        <div className="layout__item u-1/3-medium-and-up" key="zip code">
          <div className="c-label-new">{t('admin:shops.add.address.postcode_label')} *</div>
          <Input className="c-input" type="text" placeholder={t('admin:shops.add.address.add_eircode_placeholder')} name="address.zip" />
        </div>
      ));
    }

    fields.push(
      <RoleAllowAdmin key="coordinates">
        <div className="layout__item u-1/2-medium-and-up" key="latitude">
          <div className="c-label-new">{t('admin:shops.add.address.latitude_label')}</div>
          <Input
            className="c-input"
            type="number"
            placeholder={t('admin:shops.add.address.add_latitude_placeholder')}
            name="location.coordinates[0]"
            min="-90"
            max="90"
            step="any"
          />
        </div>
        <div className="layout__item u-1/2-medium-and-up" key="longitutde">
          <div className="c-label-new">{t('admin:shops.add.address.longitude_label')}</div>
          <Input
            className="c-input"
            type="number"
            placeholder={t('admin:shops.add.address.add_longitude_placeholder')}
            name="location.coordinates[1]"
            min="-180"
            max="180"
            step="any"
          />
        </div>
      </RoleAllowAdmin>
    );
    return fields;
  }

  render() {
    return (
      <div>
        <div
          className={classNames(
            'c-heading c-wrapper u-pv0 u-mb-',
            this.props.headerClassName,
          )}
        >
          {t('admin:shops.add.address.business_location_title')}
        </div>
        <div className={this.props.wrapperClassName}>
          <div className="layout">
            {this.renderFields()}
          </div>
        </div>
      </div>
    );
  }
}

AddressForm.propTypes = {
  country: PropTypes.string,
  wrapperClassName: PropTypes.string,
  headerClassName: PropTypes.string,
};

AddressForm.defaultProps = {
  country: COUNTRY_NAME_BY_CODE.US,
  wrapperClassName: 'c-wrapper-horizontal',
  headerClassName: '',
};

export default AddressForm;
